import React from 'react'
import Processes from './Processes'
export default function OnlinePayments() {
  return (
    <div><Processes /></div>
  )
}
